import { createAsyncThunk } from '@reduxjs/toolkit';

import { IPermissions, TPaymentAdjustmentTypes } from '.';
import { AdminApiPaths, TApiResponse, APIDataProvider } from '../../../api';
import { TFlexiblePlanExpiredInTypes } from '../FlexiblePlansSlice';

// ADJUSTMENTS
export type TAdminPaymentAdjustmentCreate = {
  userId: string;
  type: TPaymentAdjustmentTypes;
  flexiblePlanId?: string;
  description?: string;
  numberOfHours?: number;
  rate?: number;
  currency?: string;
  courseId?: string;
  expiredIn?: {
    count: number;
    type: TFlexiblePlanExpiredInTypes;
  };
};

const apiDataProvider = new APIDataProvider();

// PERMISSION
export const adminGetPermissions = createAsyncThunk(
  '/admin/settings/permissions/get',
  async () => {
    const path = `${AdminApiPaths.adminSettings}/permissions`;
    const response = await apiDataProvider.get<TApiResponse<IPermissions>>(
      path
    );

    return response.data;
  }
);

// ADJUSTMENTS
export const adminCreatePaymentAdjustment = createAsyncThunk(
  '/admin/settings/payment-adjustments/create',
  async (data: TAdminPaymentAdjustmentCreate) => {
    const path = `${AdminApiPaths.adminSettings}/payment-adjustments`;
    const response = await apiDataProvider.post<
      TApiResponse<{ status: string }>
    >(path, data);

    return response.data;
  }
);
